import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const AppNavbar = () => {
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    // Get user role from localStorage
    const loginData = localStorage.getItem('login');
    if (loginData) {
      try {
        const user = JSON.parse(loginData);
        setUserRole(user.role);
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, []);

  // Function to determine if a link should have the active class
  const isActive = (path) => {
    console.warn(location.pathname);
    return location.pathname === path ? 'active' : '';
  };

  // Check if current path starts with user routes
  // const isUserRouteActive = () => {
  //   return location.pathname.startsWith('/user') ? 'active' : '';
  // };


  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="#dashboard">મિશન હોસ્પિટલ</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link className={isActive('/')}>
              <Link to="/">Dashboard</Link>
            </Nav.Link>
            <Nav.Link className={isActive('/donation-list')}>
              <Link to="/donation-list">Donation Amount</Link>
            </Nav.Link>
            <Nav.Link className={isActive('/list')}>
              <Link to="/list">Donation Receipt</Link>
            </Nav.Link>
            <Nav.Link className={isActive('/contribution-list')}>
              <Link to="/contribution-list">Contribution</Link>
            </Nav.Link>
            <Nav.Link className={location.pathname.startsWith('/expense') ? 'active' : ''}>
              <Link to="/expense-list">Expenses</Link>
            </Nav.Link>
            {userRole === 'admin' && (
              <Nav.Link className={isActive('/user-list')}>
                <Link to="/user-list">Users</Link>
              </Nav.Link>
            )}
            {userRole === 'admin' && (
              <Nav.Link className={isActive('/user-wise-statistics')}>
                <Link to="/user-wise-statistics">User Wise Statistics</Link>
              </Nav.Link>
            )}
            <Nav.Link className={isActive('/logout')}>
              <Link to="/logout">Logout</Link>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
